// assets/product-nutrition.js
(function() {
  'use strict';

  function renderNutritionFooter(container, footerLines) {
    var footerEl = container.querySelector('.nutrition-footer');
    if (!footerLines || !Array.isArray(footerLines) || footerLines.length === 0) {
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    if (!footerEl) {
      footerEl = document.createElement('p');
      footerEl.className = 'nutrition-footer';
      var inner = container.querySelector('.product-nutrition__inner');
      if (inner) inner.appendChild(footerEl);
    }
    footerEl.style.display = '';
    footerEl.innerHTML = footerLines.map(function(line) {
      if (line.indexOf('DDR') !== -1 || line.indexOf('VRN') !== -1) {
        var idx = line.indexOf(': ');
        if (idx === -1) return '<em>' + line + '</em>';
        return '<em><strong>' + line.substring(0, idx) + '</strong>: ' + line.substring(idx + 2) + '</em>';
      }
      return line;
    }).join('<br>');
  }

  window.initNutritionSelector = function(tab) {
    var button = tab.querySelector('.m-collapsible--button');
    var dataScript = tab.querySelector('.nutrition-data');
    if (!button || !dataScript) return;

    var existing = button.querySelector('.nutrition-selector');
    if (existing) existing.remove();

    var rawData;
    try {
      rawData = JSON.parse(dataScript.textContent);
      if (typeof rawData === 'string') rawData = JSON.parse(rawData);
    } catch (e) { return; }

    var portions, footerLines;
    if (rawData && rawData.porciones && Array.isArray(rawData.porciones)) {
      portions = rawData.porciones;
      footerLines = rawData.footer || [];
    } else if (Array.isArray(rawData)) {
      portions = rawData;
      footerLines = [];
    } else {
      return;
    }

    if (!portions || portions.length === 0) return;

    renderNutritionFooter(tab, footerLines);

    if (portions.length === 1) {
      renderPortion(portions[0].label);
      var staticWrapper = document.createElement('div');
      staticWrapper.className = 'nutrition-selector';
      staticWrapper.style.cssText = 'position:absolute; right:4rem; display:none; align-items:center;';
      staticWrapper.addEventListener('click', function(e) { e.stopPropagation(); });
      var staticDisplay = document.createElement('div');
      staticDisplay.className = 'nutrition-selector-display';
      staticDisplay.style.cssText = 'position:relative; display:flex; align-items:center; z-index:1;';
      var staticText = document.createElement('span');
      staticText.className = 'nutrition-selected-text';
      staticText.textContent = portions[0].label;
      staticText.style.setProperty('font-size', '14px', 'important');
      staticText.style.setProperty('font-weight', 'normal', 'important');
      staticText.style.setProperty('line-height', 'normal', 'important');
      staticText.style.setProperty('white-space', 'normal', 'important');
      staticDisplay.appendChild(staticText);
      var vrnLabel = portions[0].vrn_label || '';
      if (vrnLabel) {
        var vrnEl = document.createElement('span');
        vrnEl.className = 'nutrition-vrn-text';
        vrnEl.innerHTML = vrnLabel;
        vrnEl.style.setProperty('font-size', '14px', 'important');
        vrnEl.style.setProperty('line-height', 'normal', 'important');
        vrnEl.style.setProperty('margin-left', '0', 'important');
        vrnEl.style.setProperty('white-space', 'nowrap', 'important');
        staticDisplay.appendChild(vrnEl);
      }
      staticWrapper.appendChild(staticDisplay);
      button.style.position = 'relative';
      button.appendChild(staticWrapper);
      var obs = new MutationObserver(function(muts) {
        muts.forEach(function(m) {
          if (m.attributeName === 'aria-expanded') {
            staticWrapper.style.display = button.getAttribute('aria-expanded') === 'true' ? 'flex' : 'none';
          }
        });
      });
      obs.observe(button, { attributes: true });
      if (button.getAttribute('aria-expanded') === 'true') {
        staticWrapper.style.display = 'flex';
      }
      return;
    }

    var selectorWrapper = document.createElement('div');
    selectorWrapper.className = 'nutrition-selector';
    selectorWrapper.style.cssText = 'position:absolute; right:4rem; display:none; align-items:center; cursor:pointer;';
    selectorWrapper.addEventListener('click', function(e) { e.stopPropagation(); });

    var arrowIcon = document.createElement('span');
    arrowIcon.className = 'nutrition-selector-arrow';
    arrowIcon.innerHTML = '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.1384 6.02928C3.32935 5.80651 3.66472 5.78071 3.88749 5.97165L8.50009 9.92531L13.1127 5.97165C13.3355 5.78071 13.6708 5.80651 13.8618 6.02928C14.0527 6.25204 14.0269 6.58742 13.8042 6.77837L8.84582 11.0284C8.64688 11.1989 8.3533 11.1989 8.15436 11.0284L3.19602 6.77836C2.97326 6.58742 2.94746 6.25204 3.1384 6.02928Z" fill="black"/></svg>';

    var select = document.createElement('select');
    select.id = 'nutrition-portion';
    select.style.cssText = 'position:absolute; left:0; top:0; width:100%; height:100%; opacity:0; cursor:pointer; z-index:2;';
    select.addEventListener('click', function(e) { e.stopPropagation(); });
    select.addEventListener('focus', function() { arrowIcon.classList.add('rotated'); });
    select.addEventListener('blur', function() { arrowIcon.classList.remove('rotated'); });
    select.addEventListener('change', function() {
      setTimeout(function() {
        if (document.activeElement !== select) arrowIcon.classList.remove('rotated');
      }, 100);
    });

    var displayContent = document.createElement('div');
    displayContent.className = 'nutrition-selector-display';
    displayContent.style.cssText = 'position:relative; display:flex; align-items:center; pointer-events:none; z-index:1;';

    var selectedText = document.createElement('span');
    selectedText.className = 'nutrition-selected-text';
    selectedText.textContent = portions[0].label;
    selectedText.style.setProperty('font-size', '14px', 'important');
    selectedText.style.setProperty('font-weight', 'normal', 'important');
    selectedText.style.setProperty('line-height', 'normal', 'important');
    selectedText.style.setProperty('white-space', 'normal', 'important');
    displayContent.appendChild(selectedText);

    var vrnText = document.createElement('span');
    vrnText.className = 'nutrition-vrn-text';
    var firstVrn = portions[0].vrn_label || '';
    vrnText.innerHTML = firstVrn;
    vrnText.style.setProperty('font-size', '14px', 'important');
    vrnText.style.setProperty('line-height', 'normal', 'important');
    vrnText.style.setProperty('margin-left', '0', 'important');
    vrnText.style.setProperty('white-space', 'nowrap', 'important');
    if (!firstVrn) vrnText.style.display = 'none';
    displayContent.appendChild(vrnText);

    displayContent.appendChild(arrowIcon);
    selectorWrapper.appendChild(displayContent);
    selectorWrapper.appendChild(select);

    portions.forEach(function(p, i) {
      var opt = document.createElement('option');
      opt.value = p.label;
      opt.textContent = p.label;
      if (i === 0) opt.selected = true;
      select.appendChild(opt);
    });

    button.style.position = 'relative';
    button.appendChild(selectorWrapper);

    function renderNutritionTable(valores) {
      var tbody = tab.querySelector('.product-nutrition-table tbody');
      if (!tbody || !valores || !Array.isArray(valores)) return;
      tbody.innerHTML = '';
      valores.forEach(function(item) {
        var tr = document.createElement('tr');
        tr.innerHTML = '<th class="nutrition-main">' + item.nombre + '</th>' +
          '<td>' + (item.valor || '—') + '</td>';
        tbody.appendChild(tr);
        if (item.sub && Array.isArray(item.sub)) {
          item.sub.forEach(function(subItem) {
            var subTr = document.createElement('tr');
            subTr.innerHTML = '<th class="nutrition-sub">' + subItem.nombre + '</th>' +
              '<td>' + (subItem.valor || '—') + '</td>';
            tbody.appendChild(subTr);
          });
        }
      });
    }

    function renderPortion(label) {
      var data = portions.find(function(x) { return x.label === label; }) || {};
      if (data.valores && Array.isArray(data.valores)) {
        renderNutritionTable(data.valores);
      } else {
        tab.querySelectorAll('.nut-cell').forEach(function(td) {
          td.textContent = data[td.getAttribute('data-key')] || '—';
        });
      }
    }

    select.addEventListener('change', function() {
      renderPortion(select.value);
      selectedText.textContent = select.value;
      var selectedPortion = portions.find(function(x) { return x.label === select.value; });
      var vrnLabel = selectedPortion ? (selectedPortion.vrn_label || '') : '';
      vrnText.innerHTML = vrnLabel;
      vrnText.style.display = vrnLabel ? '' : 'none';
    });

    var obs = new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.attributeName === 'aria-expanded') {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          selectorWrapper.style.display = expanded ? 'flex' : 'none';
          if (expanded) renderPortion(select.value);
        }
      });
    });
    obs.observe(button, { attributes: true });

    if (button.getAttribute('aria-expanded') === 'true') {
      selectorWrapper.style.display = 'flex';
      renderPortion(select.value);
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('collapsible-tab').forEach(function(tab) {
      if (tab.querySelector('.nutrition-data')) {
        window.initNutritionSelector(tab);
      }
    });
  });
})();
